export default __webpack_public_path__ + "static/media/facebook.64416a39.svg";